import { Form } from "formik";
import React from "react";
import * as yup from "yup";

import { ALL_STATES, STATES } from "@/constants/states";
import { Button2 } from "@/ui2/atoms/Button";
import { CustomForm } from "@/component-library/CustomForm";
import FormikInput from "@/components/UI/FormikInput";
import FormikInputFormat from "@/components/UI/formikMobileInput";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import images from "@/utils/images";

const SecondaryAccountInfo = (props) => {
  const { accountData, nextStep, setAccountData } = props;

  const submitHandler = async (formData) => {
    const mergedAccountData = { ...accountData, ...formData };

    setAccountData(mergedAccountData);
    nextStep();
  };

  const referral_care_navigator_facilities = [
    {
      display: "Albany Medical Center",
      value: "albany_medical_center",
    },
    {
      display: "Samaritan Hospital",
      value: "samaritan_hospital",
    },
    {
      display: "St. Peter's Hospital",
      value: "st_peters_hospital",
    },
  ].sort((f1, f2) => {
    return f1.value < f2.value ? -1 : 1;
  });

  const renderForm = (formikProps) => {
    const formikInputProps = {
      errors: formikProps.errors,
      touched: formikProps.touched,
    };

    return (
      <Form>
        <div className="mx-auto px-0 mb-3">
          <div className="container px-0">
            <div>
              <h6 className="w-100 mt-xl-3">
                <b>Address</b>
              </h6>

              <div className="d-lg-flex justify-content-lg-between d-block">
                <div className="justify-content-between-input">
                  <FormikInput
                    {...formikInputProps}
                    formEl={{
                      elementConfig: {
                        label: "Street",
                        placeholder: "Enter Street",
                        type: "text",
                      },
                      elementType: "input",
                      name: "address.street",
                    }}
                    testId="self-sign-up-address-street"
                  />
                </div>

                <div className="justify-content-between-input">
                  <FormikInput
                    {...formikInputProps}
                    formEl={{
                      elementConfig: {
                        label: "City",
                        placeholder: "Enter City",
                        type: "text",
                      },
                      elementType: "input",
                      name: "address.city",
                    }}
                    testId="self-sign-up-address-city"
                  />
                </div>
              </div>

              <div className="d-lg-flex justify-content-lg-between d-block">
                <div className="justify-content-between-input">
                  <FormikInput
                    {...formikInputProps}
                    formEl={{
                      elementConfig: {
                        label: "State",
                        options: accountData.interested_in_guardianship ? ALL_STATES : STATES,
                        placeholder: "Enter State",
                      },
                      elementType: "select",
                      name: "address.state",
                    }}
                    testId="self-sign-up-address-state"
                  />
                </div>

                <div className="justify-content-between-input">
                  <FormikInput
                    {...formikInputProps}
                    formEl={{
                      elementConfig: {
                        label: "Zip",
                        placeholder: "Enter Zip",
                        type: "text",
                      },
                      elementType: "input",
                      name: "address.zip_code",
                    }}
                    testId="self-sign-up-address-zip-code"
                  />
                </div>
              </div>

              <hr />

              <div className="d-lg-flex justify-content-lg-between d-block">
                <div className="justify-content-between-input">
                  <FormikInput
                    {...formikInputProps}
                    formEl={{
                      elementConfig: {
                        label: "How did you hear about aptihealth?",
                        options: [
                          {
                            display: "Medical specialist (i.e., not primary care)",
                            value: "another_doctor",
                          },
                          {
                            display: "aptihealth Care Navigator",
                            value: "aptihealth_care_navigator",
                          },
                          {
                            display: "Communication from aptihealth",
                            value: "communication_from_aptihealth",
                          },
                          {
                            display: "Friend or family",
                            value: "friend_or_family",
                          },
                          {
                            display: "Hospital or emergency room",
                            value: "hospital_or_emergency_room",
                          },
                          {
                            display: "My employer",
                            value: "my_employer",
                          },
                          {
                            display: "My health insurance",
                            value: "my_health_insurance",
                          },
                          {
                            display: "My primary care provider",
                            value: "my_primary_care_provider",
                          },
                          {
                            display: "Search engine",
                            value: "search_engine",
                          },
                          { display: "Other", value: "other" },
                        ],
                        placeholder: "Select one...",
                        sentenceCase: false,
                      },
                      elementType: "select",
                      name: "referral_source",
                    }}
                    testId="self-sign-up-referral-source"
                  />
                </div>

                <div className="justify-content-between-input">
                  {formikProps?.values["referral_source"] === "other" && (
                    <FormikInput
                      {...formikInputProps}
                      formEl={{
                        elementConfig: {
                          label: "Please Specify (Optional)",
                          placeholder: "",
                          type: "text",
                        },
                        elementType: "input",
                        name: "referral_source_other",
                      }}
                      testId="self-sign-up-referral-source-other"
                    />
                  )}

                  {formikProps?.values["referral_source"] === "aptihealth_care_navigator" && (
                    <FormikInput
                      {...formikInputProps}
                      formEl={{
                        elementConfig: {
                          label: "Facility Name",
                          options: referral_care_navigator_facilities,
                          placeholder: "Select one...",
                        },
                        elementType: "select",
                        name: "referral_care_navigator_facility",
                      }}
                      testId="self-sign-up-referral-care-nav-facility"
                    />
                  )}
                </div>
              </div>

              <hr />

              <div className="d-lg-flex justify-content-lg-between d-block">
                <div className="justify-content-between-input">
                  <FormikInput
                    {...formikInputProps}
                    formEl={{
                      elementConfig: {
                        label: "Emergency Contact Person (Optional)",
                        placeholder: "Enter Emergency Contact Person",
                        type: "text",
                      },
                      elementType: "input",
                      name: "emergency_contact_person",
                    }}
                    testId="self-sign-up-emergency-contact-person"
                  />
                </div>

                <div className="justify-content-between-input">
                  <FormikInputFormat
                    {...formikInputProps}
                    formEl={{
                      elementConfig: {
                        label: "Emergency Contact Number (Optional)",
                        placeholder: "Enter Emergency Contact Number",
                        type: "text",
                      },
                      elementType: "input",
                      name: "emergency_contact_number",
                    }}
                    onChange={async (val) => {
                      await formikProps.setFieldValue("emergency_contact_number", val.value);
                      formikProps.setFieldTouched("emergency_contact_number");
                    }}
                    testId="self-sign-up-emergency-contact-number"
                    value={formikProps && formikProps.values["emergency_contact_number"]}
                  />
                </div>
              </div>

              <div className="d-lg-flex justify-content-lg-between d-block">
                <div className="justify-content-between-input">
                  <FormikInput
                    {...formikInputProps}
                    formEl={{
                      elementConfig: {
                        label: "Primary Care Provider (Optional)",
                        placeholder: "Enter PCP Name",
                        type: "text",
                      },
                      elementType: "input",
                      name: "pcp_name",
                    }}
                    testId="self-sign-up-pcp-name"
                  />
                </div>

                <div className="justify-content-between-input">
                  <FormikInput
                    {...formikInputProps}
                    formEl={{
                      elementConfig: {
                        label: "Primary Care Location (Optional)",
                        placeholder: "Enter Primary Care Location",
                        type: "text",
                      },
                      elementType: "input",
                      id: "pcp_location",
                      name: "pcp_location",
                    }}
                    testId="self-sign-up-pcp-location"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex tw:justify-center">
          <Button2
            className="tw:min-w-40"
            size="xl"
            type="submit"
            {...getAutomationDataAttr("self-sign-up-secondary-info-button")}
          >
            Continue
          </Button2>
        </div>
      </Form>
    );
  };

  return (
    <>
      <div className="p-5">
        <div className="fs-22 txt-pri mb-5 text-center tw:font-bold">
          Please complete your profile
        </div>
        <div className="text-center my-5">
          <img
            alt="Step 2/3"
            className="signup-progress-bar"
            src={images("./signup/progress-2.png")}
          />
        </div>
        <CustomForm
          initialValues={accountData}
          onSubmit={submitHandler}
          render={renderForm}
          validationSchema={accountPart2Validation}
        />
      </div>
    </>
  );
};

export default SecondaryAccountInfo;

const accountPart2Validation = yup.object().shape({
  address: yup.object().shape({
    city: yup
      .string()
      .required("City is required")
      .matches(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/, "Enter a valid city")
      .nullable(),
    state: yup.string().required("State is required").nullable(),
    street: yup.string().trim().required("Street is required"),
    zip_code: yup
      .string()
      .required("Zip code is required")
      .matches(/^\d{5}(?:[-\s]\d{4})?$/, "Enter a valid zip code")
      .nullable(),
  }),
  referral_care_navigator_facility: yup.string().when("referral_source", {
    is: (val) => val === "aptihealth_care_navigator",
    otherwise: () => yup.string().nullable(),
    then: () => yup.string().required("Care Navigator Facility Name is required"),
  }),
  referral_source: yup.string().required("How did you hear about aptihealth is required"),
});
